import logo from '@cannect/assets/svg/logo2.svg'
import { useTopMarquee } from '@cannect/contexts/TopMarqueeContext'
import CartSheet from '@cannect/new-components/CartSheet'
import { Button, Icons, Link } from '@cannect/new-components/atoms'
import { useEffect, useState } from 'react'
import { LuHeart, LuMenu } from 'react-icons/lu'
import { useHistory } from 'react-router-dom'
import { MobileMenuSheet } from './MobileMenuSheet'
import SearchAutocomplete from './SearchAutocomplete'
import { useHeader } from './useHeader'

import { CounterBadge } from '@cannect/new-components/molecules'

/**
 * O protótipo do Novo Marketplace não tem versão mobile — a estrutura atual
 * (logo + ícones + hambúrguer, busca abaixo) é mantida de propósito, só realinhada
 * aos tokens novos (`marketplace-*`). O breakpoint é `xl` (ver HeaderUI).
 */
export const HeaderMobile = ({
  menuConfig,
  headerCtas,
  signedUserName,
  handleLogout,
  isLogged,
  cartProductsQuantity,
  isLoadingCartQuantity,
  isPublicFlow,
  showSubscriptions
}: ReturnType<typeof useHeader>) => {
  const [isCartSheetOpen, setIsCartSheetOpen] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { setMenuOpen } = useTopMarquee()
  const history = useHistory()

  const handleCartClick = () => {
    history.push('/carrinho')
  }

  const handleMenuToggle = () => {
    const newMenuState = !isMenuOpen
    setIsMenuOpen(newMenuState)
    setMenuOpen(newMenuState)
  }

  useEffect(() => {
    setMenuOpen(isMenuOpen)
  }, [isMenuOpen, setMenuOpen])

  return (
    <>
      <div className="container w-full bg-gray-50 py-4">
        <div className="flex items-center justify-between gap-4">
          <Link to="/" aria-label="Cannect — página inicial">
            <img src={logo} alt="Cannect" className="aspect-[5.99] w-24 object-contain" />
          </Link>

          <div className="flex items-center gap-3">
            {!isPublicFlow && (
              <Link to="/meus-favoritos" className="text-marketplace-800">
                <LuHeart className="h-5 w-5" />
                <span className="sr-only">Favoritos</span>
              </Link>
            )}

            {!isPublicFlow && (
              <button
                type="button"
                onClick={handleCartClick}
                className="relative flex items-center justify-center border-none bg-transparent p-1 text-marketplace-800">
                <Icons.ShoppingBag className="h-5 w-5" />
                <CounterBadge quantity={cartProductsQuantity} isLoading={isLoadingCartQuantity} />
                <span className="sr-only">Carrinho</span>
              </button>
            )}

            <Button unstyled onClick={handleMenuToggle}>
              <LuMenu className="!h-6 !w-6 text-marketplace-800" />
              <span className="sr-only">Abrir menu de navegação</span>
            </Button>
          </div>
        </div>

        {!isPublicFlow && (
          <div className="mt-4">
            <SearchAutocomplete isLogged={isLogged} className="w-full" />
          </div>
        )}
      </div>

      <CartSheet isOpen={isCartSheetOpen} onClose={() => setIsCartSheetOpen(false)} />

      <MobileMenuSheet
        isOpen={isMenuOpen}
        onClose={() => {
          setIsMenuOpen(false)
          setMenuOpen(false)
        }}
        menuConfig={menuConfig}
        headerCtas={headerCtas}
        signedUserName={signedUserName}
        isLogged={isLogged}
        handleLogout={handleLogout}
        showSubscriptions={showSubscriptions}
      />
    </>
  )
}
